import React, { Component } from 'react';
import { connect } from 'react-redux';
import Order from '../components/Order.jsx'
import Navigation from '../components/Navigation.jsx'

export class Board extends Component {
  constructor(props){
    super(props);
    // console.log('Board,jsx-12 ==> props', props);
    this.state = {
      page: 0,
      totalPages: 0,
      orders: this.filterOrders(this.props.orders, 0),
      groupedOrders: []
    };
  }

  componentWillMount(){
    let tempState = this.state;
    tempState.totalPages = tempState.orders.length - 1;
    this.setState(tempState);
  }


  async componentWillReceiveProps(nextProps) {
    if(nextProps.orders.items && nextProps.orders.items.length > 0) {
      let tempState = this.state;
      tempState.orders = await nextProps.orders.items;
      tempState.groupedOrders = this.groupByOrderId(tempState.orders);
      this.setState(tempState);
    }
    // let tempState = this.state;
    // tempState.orders = this.filterOrders(nextProps.orders, nextProps.display.show);
    // tempState.totalPages = tempState.orders.length - 1;

    // if(tempState.page > tempState.totalPages){
    //   tempState.page -= 1;
    // }

    // if(tempState.orders.length === 0){
    //   tempState.totalPages = 0;
    //   tempState.page = 0;
    // }

    // this.setState(tempState);
  }

   /**
   * @name groupByOrderId
   * @description Loops through array of objects to create a new one where products are grouped by order ID
   * @param {Array} orders Array of objects
   * @returns {Array} groupedOrders Array of objects updated
   */
  groupByOrderId(orders) {
    let groupedOrders = [];
    // Initializing with array's firt order values
    let subOrderGroup = {
      order_id: orders[0].order_id,
      purchase_place: '',
      purchase_date: '',
      order_grand_total: '',
      product_price_currency: '',
      product_list: [orders[0]],
      is_shopify: 0
    };

    orders.forEach((order) => {

      if(!order.order_id) {
        // throw new Error(`From src/js/containers/Board.jsx --> The order ${order} does not have an order_id.`);
        // console.log('Skipped order:');
        // console.log(order);
        return;
      }
      // Check if oder_id already exists in the groupedOrders array.
      // eslint-disable-next-line
      const foundObject = groupedOrders.find((object, index) => {
        if (object.order_id === order.order_id) {
          // Add product's image url
          order['picture_url'] = this.createProductImageUrl(order);
          groupedOrders[index].product_list.push(order);
          return true; // stop searching
        }
      });

      if(!foundObject) {
        order['picture_url'] = this.createProductImageUrl(order);
        // Re-initialize
        subOrderGroup = {
          order_id: order.order_id,
          purchase_place: '',
          purchase_date: '',
          order_grand_total: '',
          product_price_currency: '',
          product_list: [order],
          is_shopify: 0
        };
        groupedOrders.push(subOrderGroup);
      }
    })
    groupedOrders.forEach((item, j) => {
      item.product_list.forEach(pItem => {
        if (pItem.is_shopify === 1) {
          item.is_shopify = 1
          item.order_id_origin = pItem.order_id_origin
        }
        if (!item.purchase_place) item.purchase_place = pItem.purchase_place
        if (!item.purchase_date) item.purchase_date = pItem.purchase_date
        if (!item.order_grand_total) item.order_grand_total = pItem.order_grand_total
        if (!item.product_price_currency) item.product_price_currency = pItem.product_price_currency
      })
    })
    return groupedOrders;
  }

  /**
   * @name createProductImageUrl
   * @description creates the product's image url according to sku number and desired quality and size.
   * @param {Array} product
   * @returns {string} url
   */
   createProductImageUrl(product) {
    const image_width = 350;
    const image_height = 350;
    const quality = 80;
    return 'https://imgcdn.apm-monaco.cn/products-images/' +
      product.product_sku +
      '.jpg?x-oss-process=image/resize,w_' +
      image_width +
      ',h_' +
      image_height +
      '/quality,q_' +
      quality;
   }

  filterOrders = (orders, show) =>{
    let tempOrders = [];

    if(show !== 0){
      for(let i = orders.length - 1; i >= 0 ; i--){
        if(orders[i].status === show-1){
            tempOrders.push(orders[i]);
        }
      }
      return this.splitOrders(tempOrders.slice(), 8);
    }else{
      return this.splitOrders(orders.slice().reverse(), 8);
    }
  }

  splitOrders = (orders, size) => {
    let array = [];
    for(let i = 0; i < orders.length; i += size) {
      array.push(orders.slice(i, i+size));
    }
    return array;
  }

  nextPage = () => {
    if(this.state.page < this.state.totalPages){
      let tempState = this.state;
      tempState.page += 1;
      this.setState(tempState);
    }
  }

  prevPage = () => {
    if(this.state.page > 0){
      let tempState = this.state;
      tempState.page -= 1;
      this.setState(tempState);
    }
  }

  // 新增方法来计算商品总数
  calculateTotalQuantity = () => {
    return this.state.groupedOrders.reduce((total, groupedOrder) => {
      groupedOrder.product_list.forEach(product => {
        console.log("Adding quantity: ", product.product_qty); // 打印每个商品的数量
        total += product.product_qty; // 累加每个商品的数量
      });
      return total;
    }, 0); // 初始化总数量为 0
  }
  render(){
    // console.log(this.state.page);
    let translated = this.state.page * (-100);
    const totalQuantity = this.calculateTotalQuantity(); // 获取商品总数
    console.log("Total Quantity: ", totalQuantity);
    return (
      <div className="board container">
        {/* 显示总商品数 */}
        <div className="total-quantity">
          <h3>Total Quantity: {totalQuantity}</h3>
        </div>

        {
          this.state.groupedOrders.map((groupedOrder, i) => (
            <div key={groupedOrder.order_id} className="groupedOrders-container" style={{transform: "translateX("+translated+"%)"}}>
              <Order
                id={groupedOrder.purchase_date}
                index={groupedOrder.purchase_date}
                data={groupedOrder}
              />
            </div>
          ))
        }


        <Navigation
          page={this.state.page}
          totalPages={this.state.totalPages}
          nextPage={this.nextPage}
          prevPage={this.prevPage}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    display: state.display
  }
}

export default connect(
  mapStateToProps
)(Board);



// WEBPACK FOOTER //
// ./src/js/containers/Board.jsx